import React, { useEffect, useState } from "react";
import { FaFileExport, FaSearch, FaUserPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import Header from "../../Components/HeaderAdmin/Header";
import CustomSelect from "./SelectBar";
import { getremoteInquiryapi } from '../../Api/iron'
import { Form } from "react-bootstrap";
import { Roller } from "react-awesome-spinners";
import { FaCalendarAlt } from "react-icons/fa";
import Loader2 from "../DashboardComponents/Loader/Loader2";
import { IoCloseSharp } from "react-icons/io5";
import CustomSelect2 from "../FollowUps/SelectBar2";
import RemoateFittingAdmin from "../../Components/RemoateFitting/RemoateFittingAdmin";
import addprescription from '../../assets/images/addprescription.svg'
import Pagination from './Pagination';

function RemoteInquiries() {

    const [isLoading, setIsLoading] = useState(true);

    const initCustomerClub = {
        fitting:
        {
            label: 'Sort By : Fitting',
            value: "0",
            icon: '1'
        },
        queue:
        {
            label: 'Sort By : Queue',
            value: null,
            icon: '1'
        },
        status:
        {
            label: 'Sort By : Status',
            value: null,
            icon: '1'
        },
        fillter:
        {
            label: '10',
            value: null,
            icon: '1'
        }
    };

    const dropdownStatusOptions = [
        {
            label: "All",
            icon: "0",
            value: null
        },
        {
            label: "Inquiry",
            icon: "0",
            value: "0"
        },
        {
            label: "Contacted",
            icon: "1",
            value: "1"
        },
        {
            label: "Invoiced",
            icon: "3",
            value: '3'
        },
        {
            label: "Purchased",
            icon: "4",
            value: '4'
        }
    ];

    const dropdownStatusOptions2 = [
        {
            label: "All",
            icon: "0",
            value: null
        },
        {
            label: "Righty",
            icon: "1",
            value: 1
        },
        {
            label: "Lefty",
            icon: "2",
            value: 2
        },
        {
            label: "TPT",
            icon: "3",
            value: 3
        },
        {
            label: "Tall",
            icon: "4",
            value: 4
        },
        {
            label: "Junior",
            icon: "5",
            value: 5
        },
        {
            label: "Biz Dev",
            icon: "6",
            value: 6
        },
        {
            label: "Quad",
            icon: "7",
            value: 7
        }
    ];

    const dropdownStatusOptionsThird = [
        {
            label: "All",
            icon: "0",
            value: 'all'
        },
        {
            label: "10",
            icon: "0",
            value: 10
        },
        {
            label: "30",
            icon: "1",
            value: 30
        },
        {
            label: "50",
            icon: "1",
            value: 50
        },
    ];


    const [dataNull, setDataNull] = useState(null);
    const [apicall, setApicall] = useState(false);
    const [errors, setErrors] = useState([]);
    const [validated, setValidated] = useState(false);

    const [selectedKeyword, setSelectedKeyword] = useState(initCustomerClub.status);
    const [selectedKeywordqueue, setSelectedKeywordqueue] = useState(initCustomerClub.queue);
    const [PaginationKeyword, setPaginationKeyword] = useState(initCustomerClub.fillter);
    const [filteredData, setFilteredData] = useState([]);
    const [remoteInquiryData, setRemoteInquiryData] = useState([]);
    const [keyword, setKeyword] = useState("");

    useEffect(() => {
        getremoteInquirydata()
    }, [])

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // or whatever you want as default
    const [totalPages, setTotalPages] = useState(1); // set from API response

    const [isMobile, setIsMobile] = useState(false);

    const getremoteInquirydata = (stage, keyword = '', queue_status, page = 1, pageSize = 10) => {
        setApicall(true);
        setIsLoading(true);

        if (stage === undefined) {
            stage = "All"
        }

        const data = {
            stage: stage,
            keyword: keyword,
            queue_status: queue_status,
            fitting_type: "remotefitting_query",
            remote_kit_id: "0",
            pageNumber: page,
            pageSize: pageSize,
        }

        getremoteInquiryapi(data).then((response) => {
            if (!response.data.status) {
                setErrors(response.data.error);
            } else {
                const data = response.data.data;
                setFilteredData(data.items);
                setRemoteInquiryData(data.items);
                setTotalPages(data.totalPages);
                setDataNull(!null);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
    
        // Initial check
        handleResize();
    
        // Event listener for resize
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);

    const downloadRemoteInquiryCSV = async (stage = "All", keyword = '', queue_status) => {
        try {
            setApicall(true);
            setIsLoading(true);

            // request with large pageSize (1000)
            const data = {
                stage: stage,
                keyword: keyword,
                fitting_type: "remotefitting_query",
                remote_kit_id: "0",
                pageNumber: 1,
                pageSize: 1000,   // Fetch maximum records
            };

            const response = await getremoteInquiryapi(data);

            if (!response.data.status) {
                setErrors(response.data.error);
                return;
            }

            const items = response.data.data.items || [];

            // Header row
            let csv = "Status,Name,Email,Phone,Submited_Date\n";

            // Add data rows
            items.forEach(item => {
                console.log("ITEMS",item)
                let status = item.stage || "";
                let name = `${item.firstname} ${item.lastname}` || "";
                let email = item.email || "";
                let phone = item.phone || "";
                let Submited_Date = item.createdAt ? new Date(item.createdAt).toLocaleString() : "";

                // Escape commas in values if needed
                csv += `"${status}","${name}","${email}","${phone}","${Submited_Date}"\n`;
            });

            // Create a Blob for CSV
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

            // Create download link
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", "RemoteInquiryData.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (err) {
            console.error(err);
        } finally {
            setApicall(false);
            setIsLoading(false);
        }
    };

    const fittingStatusSelect = (selectedOption) => {
        setSelectedKeyword(selectedOption);
        getremoteInquirydata(selectedOption.label, keyword, selectedKeywordqueue.value);
        setKeyword('')
    };

    const fittingStatusSelectqueue = (selectedOption) => {
        setSelectedKeywordqueue(selectedOption);
        getremoteInquirydata(selectedKeyword.value, keyword, selectedOption.value);
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setValidated(true);
        getremoteInquirydata(selectedKeyword.value, keyword);
    };

    const handleSearchChange = (e) => {
        if (keyword !== "") {
            setCurrentPage(1);
            getremoteInquirydata(selectedKeyword.value, keyword, selectedKeywordqueue.value, 1, 10);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        getremoteInquirydata(selectedKeyword.value, keyword, selectedKeywordqueue.value, page, pageSize); // pass the page number and page size
    };

    const dateoptions = [
        {
            value: 'newest',
            label: 'Newest'
        },
        {
            value: 'oldest',
            label: 'Oldest'
        }
    ];


    const handleFilterPrescription2 = (value) => {
        const datefilter = value.value;

        if (datefilter === "oldest") {
            setFilteredData([...remoteInquiryData].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)));
        } else if (datefilter === "newest") {
            setFilteredData([...remoteInquiryData].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        }
    };


    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const togglePopup = () => {
        setIsPopupOpen(true);
    };


    const [loaderhandle, setLoaderhandle] = useState(false);

    useEffect(() => {
        // setIsLoading(loaderhandle); 
        getremoteInquirydata();
        setIsPopupOpen(false);
    }, [loaderhandle])

    return (
        <>
            {
                isLoading ? (
                    <div className="loading">
                        <Loader2 />
                    </div>
                ) : (
                    <>
                        <div className="main-page-body-content-header">
                            <Header />
                        </div>
                        <div className="dashboard-container d-flex build_box_dashboard_sec">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">

                                                <div className="club-fitting"  >
                                                    <div className="stations-section">
                                                        <div className="sec-header-new">
                                                            <button type="button" className="btn-header-transparent">
                                                                <div className="border_box_view">
                                                                    <div className="border_box_view_inner">
                                                                        <div className="box_icon">
                                                                            <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                                                        </div>
                                                                        <div className="box_text_content">
                                                                            <div className="big_text">Remote Inquiry</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                            <div className="header-left d-flex align-items-center gap-2 gap-md-4">
                                                                <div className="right_box_content">
                                                                    <div className="box_btn">
                                                                    <button
                                                                        className="btn btn-create custom-export"
                                                                        onClick={() => downloadRemoteInquiryCSV("All", "", "active")}
                                                                        >
                                                                        <FaFileExport />
                                                                        {!isMobile && <span className="mt-1 ms-2">Export</span>}
                                                                    </button>
                                                                    </div>
                                                                    <style>
                                                                        {`  
                                                                            @media only screen and (min-width: 320px) and (max-width: 768px){
                                                                                .custom-export{
                                                                                    max-width: 100px !important;
                                                                                    min-width: 70px !important;
                                                                                    padding: 10px !important;
                                                                                    font-size: 30px !important;
                                                                                    }
                                                                                    }
                                                                                    @media only screen and (min-width: 320px) and (max-width: 485px){
                                                                                        .custom-export{
                                                                                            max-width: 100px !important;
                                                                                            min-width: 55px !important;
                                                                                            max-height: 58px !important;
                                                                                            padding: 5px 10px !important;
                                                                                }
                                                                            }
                                                                        `}
                                                                    </style>
                                                                </div>


                                                                <button type="button" className="btn-header-transparent" onClick={togglePopup}>
                                                                    <div className="border_box_view">
                                                                        <div className="border_box_view_inner">
                                                                            <div className="box_icon" >
                                                                                <img src={addprescription} alt="" width='30' height='50' />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="filter_header">
                                                    <div className="row">
                                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
                                                            <div className="filter_search_box">
                                                                <div className="search_box">
                                                                    <input type="text" className="form-control filter_search_bar" value={keyword} onChange={(e) => setKeyword(e.target.value)} placeholder="Search Customer..." />
                                                                    <button className="filter_search_btn" onClick={handleSearchChange}>
                                                                        <FaSearch />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6 col-12">
                                                            <div className="dropdown-btn-list filter_dropdown_view">
                                                                <div className="btn-1">
                                                                    <CustomSelect options={dropdownStatusOptions2}
                                                                        defaultSelected={selectedKeywordqueue}
                                                                        onSelect={fittingStatusSelectqueue}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-sm-6 col-12 mt-fixx">
                                                            <div className="dropdown-btn-list filter_dropdown_view">
                                                                <div className="btn-1">
                                                                    <CustomSelect options={dropdownStatusOptions}
                                                                        defaultSelected={selectedKeyword}
                                                                        onSelect={fittingStatusSelect}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 mt-fixxx">
                                                            <div className="dropdown-btn-list filter_dropdown_view filter_search_box_new">
                                                                <div className="btn-1">
                                                                    <CustomSelect2
                                                                        options={dateoptions}
                                                                        defaultSelected='Date'
                                                                        onSelect={handleFilterPrescription2}
                                                                        category="type"
                                                                        filterType="date"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div className="col-xxl-2 col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6 mt-fix">
                                                            <div className="dropdown-btn-list filter_dropdown_view filter_search_box_new">
                                                                <div className="btn-1">
                                                                    <CustomSelect options={dropdownStatusOptionsThird}
                                                                        defaultSelected={PaginationKeyword}
                                                                        onSelect={setPagination}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>


                                                <div className="dashboard-sec">
                                                    {
                                                        dataNull === null ? null :
                                                            <>
                                                                {
                                                                    filteredData.length === 0 ? (
                                                                        <div className="no-data-found">
                                                                            <div className='no-data-img'>
                                                                                <img src={require("../../assets/images/logo_text.png")} alt="" />
                                                                            </div>
                                                                            <div className="no-data-text">
                                                                                <h3>No data Found</h3>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        filteredData && filteredData.map((item, i) => {
                                                                            return (
                                                                                <div className="black_bg_box">
                                                                                    <div className="black_bg_box_inner">
                                                                                        <div className="left_box_content">
                                                                                            <div className="list_border_boxs project-list-box">
                                                                                                <div className={`border_box_view ${getBorderColorClass(item && item.stage)}`}>
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_icon">
                                                                                                            <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g fill="#99ea24"><path d="m25 2c-3.866 0-7 3.13401-7 7 0 3.866 3.134 7 7 7h14c3.866 0 7-3.134 7-7 0-3.86599-3.134-7-7-7z" /><path clip-rule="evenodd" d="m15 9.00001c0-.6707.066-1.32598.1919-1.9597-4.0388.40511-7.1919 3.81419-7.1919 7.95969v39c0 4.4183 3.5817 8 8 8h32c4.4183 0 8-3.5817 8-8v-39c0-4.1455-3.1531-7.55458-7.1919-7.95968.1259.63371.1919 1.28899.1919 1.95969 0 5.52289-4.4771 9.99999-10 9.99999h-14c-5.5228 0-10-4.4771-10-9.99999zm13.4142 18.58579c.7811.781.7811 2.0474 0 2.8284l-6 6c-.432.4321-1.0379.6429-1.6448.5725-.6069-.0705-1.1483-.4145-1.4699-.934l-2-3.2308c-.5814-.9391-.2914-2.1718.6478-2.7532s2.1718-.2913 2.7532.6478l.6709 1.0837 4.2144-4.2144c.781-.7811 2.0474-.7811 2.8284 0zm6.5858 1.4142c-1.1046 0-2 .8954-2 2s.8954 2 2 2h10c1.1046 0 2-.8954 2-2s-.8954-2-2-2zm-2 15c0-1.1046.8954-2 2-2h10c1.1046 0 2 .8954 2 2s-.8954 2-2 2h-10c-1.1046 0-2-.8954-2-2zm-4.5858.4142c.7811-.781.7811-2.0474 0-2.8284-.781-.7811-2.0474-.7811-2.8284 0l-4.2144 4.2144-.6709-1.0837c-.5814-.9391-1.814-1.2292-2.7532-.6478s-1.2292 1.8141-.6478 2.7532l2 3.2308c.3216.5195.863.8635 1.4699.934.6069.0704 1.2128-.1404 1.6448-.5725z" fill-rule="evenodd" /></g></svg>
                                                                                                        </div>
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Remote Status:</div>
                                                                                                            {/* <div className="big_text">{getcurrentstage(item.current_stage)}</div> */}
                                                                                                            <div className="big_text">{item.stage}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_icon">
                                                                                                            <svg viewBox="-42 0 512 512.002" xmlns="http://www.w3.org/2000/svg" fill="#99ea24"><path d="m210.351562 246.632812c33.882813 0 63.222657-12.152343 87.195313-36.128906 23.972656-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.132812 87.195312 23.976563 23.96875 53.3125 36.125 87.1875 36.125zm0 0" /><path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.308594-10.339844-7.808594-20.550781-13.371094-30.335938-5.773438-10.15625-12.554688-19-20.164063-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.039063 5.339844-10.972656 0-22.085937-1.796876-33.046874-5.339844-11.210938-3.621094-20.296876-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.75-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.605469 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.058594 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.796875-1.023438 19.964844-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.441406 23.734375 65.066406 23.734375h246.53125c26.625 0 48.511719-7.984375 65.0625-23.734375 16.757813-15.945312 25.253906-37.585937 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm0 0" /></svg>

                                                                                                        </div>
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Customer:</div>
                                                                                                            <div className="big_text">{item.firstname + " " + item.lastname}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_icon">
                                                                                                            <FaCalendarAlt />
                                                                                                        </div>
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Start Date:</div>
                                                                                                            <div className="big_text">{item && formatDate(item.createdAt)}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                                <div className="border_box_view">
                                                                                                    <div className="border_box_view_inner">
                                                                                                        <div className="box_text_content">
                                                                                                            <div className="little_text">Queue:</div>
                                                                                                            <div className="big_text">{item && item.queue_status ? getqueuename(item.queue_status) : "None"}</div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="right_box_content">
                                                                                            <div className="box_btn">
                                                                                                <Link to={`/remote_inquirie_view/${item._id}`}>
                                                                                                    <button className="btn-colr">View Inquiry</button>
                                                                                                </Link>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    )
                                                                }
                                                            </>
                                                    }
                                                </div>

                                                <Pagination
                                                    currentPage={currentPage}
                                                    totalPages={totalPages}
                                                    onPageChange={handlePageChange}
                                                />

                                                {isPopupOpen && (
                                                    <RemoateFittingAdmin isPopupOpen={isPopupOpen} handleLoader={(loaderhandleNew) => setLoaderhandle(loaderhandleNew)}
                                                    />
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <style>
                                {`
                                    @media (max-width: 575px) {
                                        .mt-fixxx, .mt-fixx{
                                            margin-top: 15px !important;
                                        }
                                    }
                                    @media (max-width: 991px) {
                                        .mt-fixxx{
                                            margin-top: 15px !important;
                                        }
                                    }
                                `}
                            </style>
                        </div>
                    </>
                )
            }
        </>
    )
}

const getcurrentstage = (current_stage) => {
    switch (current_stage) {
        case '0':
            return 'Inquiry';
        case '1':
            return 'Contacted';
        case '2':
            return 'Estimated';
        case '3':
            return 'Invoiced';
        case '4':
            return 'Purchase';
        default:
            return ''; // In case the status doesn't match any case
    }
};


const getBorderColorClass = (status) => {
    switch (status) {
        case 'Inquiry':
            return 'red_border';
        case 'Contacted':
            return 'yellow_border';
        case 'Invoiced':
            return 'green_border';
        case 'Purchased':
            return 'blue_border';
        default:
            return 'default_border'; // In case the status doesn't match any case
    }
};

const getqueuename = (status) => {
    switch (status) {
        case 1:
            return 'Righty';
        case 2:
            return 'Lefty';
        case 3:
            return 'TPT';
        case 4:
            return 'Tall';
        case 5:
            return 'Junior';
        case 6:
            return 'Biz Dev';
        case 7:
            return 'Quad';
        default:
            return 'None';
    }
}

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = String(date.getUTCFullYear()).slice(-2);
    return `${month}/${day}/${year}`;
};
export default RemoteInquiries;